let mobileNavLoaded = false

const mobileQuery = window.matchMedia('(max-width: 900px)')

class MobileNavigation extends window.BAO.CustomElement() {
  connectedCallback () {
    this.setupListeners()
    this.initialise()
  }

  setupListeners () {
    super.setupListeners()

    this.initialise = this.initialise.bind(this)
    this.listeners.add(mobileQuery, 'change', this.initialise)
  }

  initialise () {
    if (mobileNavLoaded || !mobileQuery.matches) return

    mobileNavLoaded = true

    window.BAO.sectionRenderer
      .fetch('drawers', '/?view=mobile-navigation')
      .then(res => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(res.drawers)
        const myself = newDOM.querySelector(this.localName)

        this.outerHTML = myself.outerHTML
      })
      .catch(() => {
        mobileNavLoaded = false
      })
  }
}

if (!customElements.get('mobile-navigation')) {
  customElements.define('mobile-navigation', MobileNavigation)
}
